import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const busData = [
  { srNo: 1, capacity: '13 Seater', rate: '₹7200', extraKm: '₹24', local: '₹5000', extraHour: '₹400', mumbai: '₹9000', mahabaleshwar: '₹9000', shirdi: 'On Call' },
  { srNo: 2, capacity: '17 Seater', rate: '₹7500', extraKm: '₹25', local: '₹5000', extraHour: '₹400', mumbai: '₹10000', mahabaleshwar: '₹10000', shirdi: 'On Call' },
  { srNo: 3, capacity: '20 Seater', rate: '₹8100', extraKm: '₹27', local: '₹6000', extraHour: '₹400', mumbai: '₹11000', mahabaleshwar: '₹12000', shirdi: 'On Call' },
  { srNo: 4, capacity: '30 Seater', rate: '₹9600', extraKm: '₹32', local: '₹7500', extraHour: '₹400', mumbai: '₹14000', mahabaleshwar: '₹13000', shirdi: 'On Call' },
  { srNo: 5, capacity: '32 Seater', rate: '₹11100', extraKm: '₹37', local: '₹7500', extraHour: '₹400', mumbai: '₹18000', mahabaleshwar: '₹14000', shirdi: 'On Call' },
  { srNo: 6, capacity: '35 Seater', rate: '₹12000', extraKm: '₹40', local: '₹8000', extraHour: '₹400', mumbai: '₹18000', mahabaleshwar: '₹14000', shirdi: 'On Call' },
  { srNo: 7, capacity: '45 Seater', rate: '₹14400', extraKm: '₹48', local: '₹9000', extraHour: '₹400', mumbai: '₹20000', mahabaleshwar: '₹16000', shirdi: 'On Call' },
  { srNo: 8, capacity: '49 Seater', rate: '₹15000', extraKm: '₹50', local: '₹9500', extraHour: '₹400', mumbai: '₹20000', mahabaleshwar: '₹16000', shirdi: 'On Call' },
];

const NonAcBusFareCard = () => {
  const phoneNumber = '917353109555'; // Without +, just country code
  const sendWhatsApp = (capacity) => {
    const message = `Hi, I want to book a ${capacity} bus.`;
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <section style={{ backgroundColor: '#F9FEFF', padding: '40px 20px' }}>
      <div className="container">
        <h4 className="text-white bg-darkk p-3 rounded-top">NON AC BUS FARE CARD</h4>
        <div className="table-responsive">
          <table className="table table-bordered text-center align-middle">
            <thead className="table-dark">
              <tr>
                <th className='table-darkk'>SR.NO</th>
                <th className='table-darkk'>SEATING CAPACITY</th>
                <th className='table-darkk'>PER KM RATE (300 KM PACKAGE)</th>
                <th className='table-darkk'>EXTRA KM</th> 
                <th className='table-darkk'>8/80 PUNE LOCAL</th>
                <th className='table-darkk'>EXTRA HOUR</th>
                <th className='table-darkk'>MUMBAI UPTO 350 KM</th>
                <th className='table-darkk'>MAHABALESHWAR UPTO 300 KMS</th>
                <th className='table-darkk'>SHIRDI (450 KM)</th>
                <th className='table-darkk'>BOOK NOW</th>
              </tr>
            </thead>
            <tbody>
              {busData.map((bus, index) => (
                <tr key={index} className={index % 2 !== 0 ? 'table-light' : ''}>
                  <td>{bus.srNo}</td>
                  <td>{bus.capacity}</td>
                  <td>{bus.rate}</td>
                  <td>{bus.extraKm}</td>
                  <td>{bus.local}</td>
                  <td>{bus.extraHour}</td>
                  <td>{bus.mumbai}</td>
                  <td>{bus.mahabaleshwar}</td>
                  <td>{bus.shirdi}</td>
                  <td>
                    <button
                      className="btn btn-dark btn-sm"
                      onClick={() => sendWhatsApp(bus.capacity)}
                    >
                      Book Now
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default NonAcBusFareCard;
